import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrendingUp = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M9.5625 5.4375C9.5625 5.28125 9.69922 5.125 9.875 5.125H13.3125C13.4688 5.125 13.625 5.28125 13.625 5.4375L13.625 8.875C13.625 9.05078 13.4688 9.1875 13.3125 9.1875C13.1367 9.1875 13 9.05078 13 8.875V6.19922L8.83984 10.3594C8.72266 10.4766 8.50781 10.4766 8.39063 10.3594L6.125 8.07422L2.90234 11.2969C2.78516 11.4141 2.57031 11.4141 2.45313 11.2969C2.33594 11.1797 2.33594 10.9648 2.45313 10.8477L5.89063 7.41016C6.00781 7.29297 6.22266 7.29297 6.33984 7.41016L8.625 9.69531L12.5508 5.75H9.875C9.69922 5.75 9.5625 5.61328 9.5625 5.4375Z"
	})
});
const ForwardRef = forwardRef(SvgTrendingUp);
export default ForwardRef;
